/* Thee Storeduct Scroll Carousel + Product Discovery Features */
(function () {
  function initCarousel(grid) {
    if (!grid || grid.dataset.ffScrollDone) return;
    grid.dataset.ffScrollDone = '1';
    var items = Array.from(grid.querySelectorAll(
      '.product-grid__item, li[class*="product"], .product-card-wrapper, product-card'
    ));
    if (items.length < 4) return;
    var wrap = document.createElement('div');
    wrap.className = 'ff-scroll-wrap';
    var track = document.createElement('div');
    track.className = 'ff-scroll-track';
    grid.parentNode.insertBefore(wrap, grid);
    wrap.appendChild(track);
    items.forEach(function(item) { track.appendChild(item); });
    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.className = 'ff-scroll-btn ff-prev';
    next.className = 'ff-scroll-btn ff-next';
    prev.setAttribute('aria-label', 'Previous');
    next.setAttribute('aria-label', 'Next');
    prev.innerHTML = '&#8249;';
    next.innerHTML = '&#8250;';
    wrap.appendChild(prev);
    wrap.appendChild(next);
    function scrollByDir(dir) {
      var w = track.getBoundingClientRect().width;
      track.scrollBy({ left: dir * (w * 0.75), behavior: 'smooth' });
    }
    prev.addEventListener('click', function() { scrollByDir(-1); });
    next.addEventListener('click', function() { scrollByDir(1); });
    function updateBtns() {
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    }
    track.addEventListener('scroll', updateBtns, { passive: true });
    updateBtns();
  }


  /* ── Mobile: compact [Sort ▼] [⚙ Filters] bar + bottom-sheet ── */
  function initMobileControls() {
    if (window.innerWidth > 600) return;
    if (!document.querySelector('.ts-product-grid')) return;
    var filterRow = document.querySelector('.ts-filter-row');
    if (!filterRow || filterRow.dataset.ffMobileDone) return;
    filterRow.dataset.ffMobileDone = '1';
    filterRow.dataset.ffSortDone   = '1'; // block desktop sort injection
    filterRow.dataset.ffPriceDone  = '1'; // block desktop price injection

    /* Compact bar */
    var bar = document.createElement('div');
    bar.className = 'ff-mobile-bar';
    bar.style.cssText = 'display:flex;gap:8px;padding:8px 16px 0;box-sizing:border-box;width:100%;';

    /* Sort select */
    var sortSel = document.createElement('select');
    sortSel.id = 'ff-sort-select';
    sortSel.className = 'ff-sort-select ff-mobile-sort';
    sortSel.style.cssText = 'flex:1;height:38px;padding:0 8px;font-size:13px;font-weight:600;font-family:inherit;border:1.5px solid #e8f0fe;border-radius:8px;background:#fff;color:#0d1f3c;cursor:pointer;';
    [
      { value: 'manual',           text: 'Featured' },
      { value: 'price-ascending',  text: 'Price: Low → High' },
      { value: 'price-descending', text: 'Price: High → Low' },
      { value: 'title-ascending',  text: 'Name: A–Z' },
      { value: 'title-descending', text: 'Name: Z–A' }
    ].forEach(function(o) {
      var el = document.createElement('option');
      el.value = o.value; el.textContent = o.text;
      sortSel.appendChild(el);
    });
    sortSel.value = new URLSearchParams(window.location.search).get('sort_by') || 'manual';
    sortSel.addEventListener('change', function() {
      var p = new URLSearchParams(window.location.search);
      p.set('sort_by', this.value);
      window.location.href = window.location.pathname + '?' + p.toString();
    });

    /* Filters button */
    var filtersBtn = document.createElement('button');
    filtersBtn.type = 'button'; filtersBtn.textContent = '⚙ Filter';
    filtersBtn.style.cssText = 'flex:0 0 auto;height:38px;padding:0 14px;font-size:13px;font-weight:700;font-family:inherit;border:1.5px solid #e8f0fe;border-radius:8px;background:#fff;color:#0d1f3c;cursor:pointer;white-space:nowrap;';

    bar.appendChild(sortSel);
    bar.appendChild(filtersBtn);
    filterRow.parentNode.insertBefore(bar, filterRow.nextSibling);

    /* Bottom-sheet overlay */
    var overlay = document.createElement('div');
    overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:9999;touch-action:none;';
    var sheet = document.createElement('div');
    sheet.style.cssText = 'position:absolute;bottom:0;left:0;right:0;background:#fff;border-radius:20px 20px 0 0;padding:20px 20px calc(20px + env(safe-area-inset-bottom));';

    var sheetHdr = document.createElement('p');
    sheetHdr.textContent = 'Filter by Price';
    sheetHdr.style.cssText = 'font-family:inherit;font-size:16px;font-weight:700;color:#0d1f3c;margin:0 0 16px;';

    function makeField(lbl, id, ph) {
      var wrap = document.createElement('div');
      wrap.style.cssText = 'margin-bottom:12px;';
      var label = document.createElement('label');
      label.htmlFor = id; label.textContent = lbl;
      label.style.cssText = 'display:block;font-size:12px;font-weight:600;color:#666;margin-bottom:4px;font-family:inherit;';
      var inp = document.createElement('input');
      inp.type = 'number'; inp.id = id; inp.min = '0'; inp.step = '1'; inp.placeholder = ph;
      inp.style.cssText = 'width:100%;height:42px;padding:0 12px;border:1.5px solid #e8f0fe;border-radius:8px;font-size:15px;box-sizing:border-box;font-family:inherit;';
      wrap.appendChild(label); wrap.appendChild(inp);
      return { wrap: wrap, input: inp };
    }

    var minF = makeField('Min Price ($)', 'ff-price-min', '0');
    var maxF = makeField('Max Price ($)', 'ff-price-max', 'any');

    var btnRow = document.createElement('div');
    btnRow.style.cssText = 'display:flex;gap:10px;margin-top:16px;';

    var applyBtn = document.createElement('button');
    applyBtn.type = 'button'; applyBtn.textContent = 'Apply';
    applyBtn.style.cssText = 'flex:1;height:44px;background:#ae3115;color:#fff;border:none;border-radius:8px;font-size:15px;font-weight:700;cursor:pointer;font-family:inherit;';

    var clearBtn = document.createElement('button');
    clearBtn.type = 'button'; clearBtn.textContent = 'Clear';
    clearBtn.style.cssText = 'flex:0 0 80px;height:44px;background:#f0f4ff;color:#0d1f3c;border:none;border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;font-family:inherit;';

    btnRow.appendChild(applyBtn);
    btnRow.appendChild(clearBtn);
    sheet.appendChild(sheetHdr);
    sheet.appendChild(minF.wrap);
    sheet.appendChild(maxF.wrap);
    sheet.appendChild(btnRow);
    overlay.appendChild(sheet);
    document.body.appendChild(overlay);

    function openSheet()  { overlay.style.display = 'block'; }
    function closeSheet() { overlay.style.display = 'none'; }

    filtersBtn.addEventListener('click', openSheet);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeSheet(); });

    function applyFilter(mn, mx) {
      var cards = document.querySelectorAll('.ts-product-card');
      var shown = 0;
      cards.forEach(function(c) {
        var el = c.querySelector('.ts-product-price');
        var price = el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '')) : 0;
        var hide = isNaN(price) || price < mn || price > mx;
        c.style.display = hide ? 'none' : '';
        if (!hide) shown++;
      });
      updateCount(shown, cards.length);
      closeSheet();
    }

    applyBtn.addEventListener('click', function() {
      var mn = minF.input.value ? parseFloat(minF.input.value) : 0;
      var mx = maxF.input.value ? parseFloat(maxF.input.value) : Infinity;
      applyFilter(mn, mx);
    });
    clearBtn.addEventListener('click', function() {
      minF.input.value = ''; maxF.input.value = '';
      applyFilter(0, Infinity);
    });
  }

  /* ── Feature 1: Price Sort Dropdown ── */
  function initSortDropdown() {
    if (!document.querySelector('.ts-product-grid')) return;
    var filterRow = document.querySelector('.ts-filter-row');
    if (!filterRow || filterRow.dataset.ffSortDone) return;
    filterRow.dataset.ffSortDone = '1';
    var sortBar = document.createElement('div');
    sortBar.className = 'ff-sort-bar';
    var label = document.createElement('label');
    label.htmlFor = 'ff-sort-select';
    label.textContent = 'Sort:';
    var select = document.createElement('select');
    select.id = 'ff-sort-select';
    select.className = 'ff-sort-select';
    [
      { value: 'manual',            text: 'Featured' },
      { value: 'price-ascending',   text: 'Price: Low → High' },
      { value: 'price-descending',  text: 'Price: High → Low' },
      { value: 'title-ascending',   text: 'Name: A–Z' },
      { value: 'title-descending',  text: 'Name: Z–A' }
    ].forEach(function(o) {
      var el = document.createElement('option');
      el.value = o.value; el.textContent = o.text;
      select.appendChild(el);
    });
    var currentSort = new URLSearchParams(window.location.search).get('sort_by') || 'manual';
    select.value = currentSort;
    select.addEventListener('change', function() {
      var p = new URLSearchParams(window.location.search);
      p.set('sort_by', this.value);
      window.location.href = window.location.pathname + '?' + p.toString();
    });
    sortBar.appendChild(label);
    sortBar.appendChild(select);
    filterRow.parentNode.insertBefore(sortBar, filterRow.nextSibling);
  }

  /* ── Feature 2: Price Range Filter ── */
  function initPriceFilter() {
    if (!document.querySelector('.ts-product-grid')) return;
    var anchor = document.querySelector('.ff-sort-bar') || document.querySelector('.ts-filter-row');
    if (!anchor || anchor.dataset.ffPriceDone) return;
    anchor.dataset.ffPriceDone = '1';
    var wrap = document.createElement('div');
    wrap.className = 'ff-price-filter';
    var row = document.createElement('div');
    row.className = 'ff-price-inputs';
    function makeInput(id, ph) {
      var lbl = document.createElement('label');
      lbl.htmlFor = id;
      lbl.textContent = id === 'ff-price-min' ? 'Min $' : 'Max $';
      var inp = document.createElement('input');
      inp.type = 'number'; inp.id = id; inp.className = 'ff-price-input';
      inp.min = '0'; inp.step = '1'; inp.placeholder = ph;
      lbl.appendChild(inp);
      return { label: lbl, input: inp };
    }
    var minF = makeInput('ff-price-min', '0');
    var maxF = makeInput('ff-price-max', 'any');
    var applyBtn = document.createElement('button');
    applyBtn.className = 'ff-apply-btn'; applyBtn.type = 'button'; applyBtn.textContent = 'Apply';
    var clearLink = document.createElement('a');
    clearLink.href = '#'; clearLink.className = 'ff-clear-link'; clearLink.textContent = 'Clear';
    clearLink.addEventListener('click', function(e) {
      e.preventDefault();
      minF.input.value = ''; maxF.input.value = '';
      applyFilter(0, Infinity);
    });
    row.appendChild(minF.label); row.appendChild(maxF.label);
    row.appendChild(applyBtn); row.appendChild(clearLink);
    wrap.appendChild(row);
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    applyBtn.addEventListener('click', function() {
      var mn = minF.input.value ? parseFloat(minF.input.value) : 0;
      var mx = maxF.input.value ? parseFloat(maxF.input.value) : Infinity;
      applyFilter(mn, mx);
    });
    function applyFilter(mn, mx) {
      var cards = document.querySelectorAll('.ts-product-card');
      var shown = 0;
      cards.forEach(function(c) {
        var el = c.querySelector('.ts-product-price');
        var price = el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '')) : 0;
        var hide = isNaN(price) || price < mn || price > mx;
        c.style.display = hide ? 'none' : '';
        if (!hide) shown++;
      });
      updateCount(shown, cards.length);
    }
  }

      /* ── Feature 4: Product Count Bar ── */
  /* Also triggers Load More button once real total is known */
  var ffTotalProducts = 0;

  function initProductCountBar() {
    if (!document.querySelector('.ts-product-grid')) return;
    var grid = document.querySelector('.ts-product-grid');
    if (!grid || grid.dataset.ffCountDone) return;
    grid.dataset.ffCountDone = '1';
    var bar = document.createElement('div');
    bar.className = 'ff-count-bar'; bar.id = 'ff-count-bar';
    grid.parentNode.insertBefore(bar, grid);
    var onPage = grid.querySelectorAll('.ts-product-card').length;
    bar.textContent = 'Showing ' + onPage + ' products…';
    var match = window.location.pathname.match(/\/collections\/([^\/]+)/);
    var handle = match ? match[1] : 'all';
    function countAll(page, total) {
      fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function(r) { return r.json(); })
        .then(function(d) {
          var batch = d.products ? d.products.length : 0;
          total += batch;
          if (batch === 250) {
            countAll(page + 1, total);
          } else {
            ffTotalProducts = total;
            updateCount(onPage, total);
            // Trigger Load More now that we know the real total
            if (total > onPage) { setupLoadMore(grid, onPage, total); }
          }
        })
        .catch(function() {
          ffTotalProducts = onPage;
          updateCount(onPage, onPage);
        });
    }
    countAll(1, 0);
  }

  function updateCount(visible, total) {
    var bar = document.getElementById('ff-count-bar');
    if (!bar) return;
    bar.textContent = total > visible
      ? 'Showing ' + visible + ' of ' + total + ' products'
      : 'Showing all ' + visible + ' products';
    ffTotalProducts = Math.max(ffTotalProducts, total);
  }

  /* ── Feature 3: Load More Button ── */
  function setupLoadMore(grid, loaded, total) {
    if (grid.dataset.ffLoadDone) return;
    grid.dataset.ffLoadDone = '1';
    var PAGE_SIZE = 50;
    var totalPages = Math.ceil(total / PAGE_SIZE);
    var curPage = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    if (curPage >= totalPages) return;
    var btn = document.createElement('button');
    btn.className = 'ff-load-more'; btn.type = 'button';
    btn.textContent = 'Load More — ' + loaded + ' of ' + total + ' shown';
    grid.parentNode.insertBefore(btn, grid.nextSibling);
    var loading = false;
    btn.addEventListener('click', function() {
      if (loading) return;
      loading = true; btn.textContent = 'Loading…'; btn.disabled = true;
      var nextPage = curPage + 1;
      var p2 = new URLSearchParams(window.location.search);
      p2.set('page', nextPage);
      fetch(window.location.pathname + '?' + p2.toString())
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('.ts-product-card');
          if (!newCards.length) {
            btn.textContent = 'All ' + total + ' products loaded'; btn.disabled = true; return;
          }
          newCards.forEach(function(c) { grid.appendChild(c.cloneNode(true)); });
          curPage = nextPage;
          var shown = grid.querySelectorAll('.ts-product-card:not([style*="none"])').length;
          updateCount(shown, ffTotalProducts);
          if (curPage >= totalPages) { btn.style.display = 'none'; }
          else {
            btn.textContent = 'Load More — ' + shown + ' of ' + total + ' shown';
            btn.disabled = false;
          }
          loading = false;
        })
        .catch(function() {
          btn.textContent = 'Error — try again'; btn.disabled = false; loading = false;
        });
    });
  }

  function initLoadMore() { /* handled by initProductCountBar after async count */ }

/* ── Feature 5: Sticky Scrollable Category Chips ── */
  function initStickyChips() {
    if (!document.querySelector('.ts-product-grid')) return;
    var row = document.querySelector('.ts-filter-row');
    if (!row || row.dataset.ffChipsDone) return;
    row.dataset.ffChipsDone = '1';
    var chips = Array.from(row.querySelectorAll('.ts-filter-chip'));
    if (!chips.length) return;
    var scrollWrap = document.createElement('div');
    scrollWrap.className = 'ff-chips-scroll-wrap';
    chips.forEach(function(c) { scrollWrap.appendChild(c); });
    row.innerHTML = '';
    var prevArr = document.createElement('button');
    prevArr.className = 'ff-chip-arrow ff-chip-prev';
    prevArr.innerHTML = '&#8249;'; prevArr.style.display = 'none';
    var nextArr = document.createElement('button');
    nextArr.className = 'ff-chip-arrow ff-chip-next';
    nextArr.innerHTML = '&#8250;'; nextArr.style.display = 'none';
    row.appendChild(prevArr);
    row.appendChild(scrollWrap);
    row.appendChild(nextArr);
    function check() {
      var over = scrollWrap.scrollWidth > scrollWrap.clientWidth + 4;
      prevArr.style.display = over ? 'flex' : 'none';
      nextArr.style.display = over ? 'flex' : 'none';
      if (over) {
        prevArr.disabled = scrollWrap.scrollLeft < 8;
        nextArr.disabled = scrollWrap.scrollLeft + scrollWrap.clientWidth >= scrollWrap.scrollWidth - 8;
      }
    }
    prevArr.addEventListener('click', function() { scrollWrap.scrollBy({ left: -140, behavior: 'smooth' }); });
    nextArr.addEventListener('click', function() { scrollWrap.scrollBy({ left: 140, behavior: 'smooth' }); });
    scrollWrap.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    setTimeout(check, 100);
  }

  function run() {
    document.querySelectorAll(
      '.product-grid, ul.product-grid, .collection-grid__products, results-list ul, .products-grid'
    ).forEach(initCarousel);
    initMobileControls();
    initSortDropdown();
    initPriceFilter();
    initProductCountBar();
    initLoadMore();
    initStickyChips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
